// PARAQTA — WebSocket байланысы (live updates).
//
// Reconnect: exponential backoff (2s, 4s, 8s, 16s, 30s max).
// Keepalive ping: 25 секунд сайын.
//
// state.js-тен `wsRetry` — live binding (ES module семантикасы),
// ал жаңарту тек setter-лер арқылы (setWs, incrWsRetry, resetWsRetry).

import { setWs, getWs, incrWsRetry, resetWsRetry, wsRetry } from './state.js';
import { animateNum } from '../utils/animate.js';
import { botToast } from '../features/landing/index.js';

export function connectWS() {
  const cur = getWs();
  if (cur && cur.readyState <= 1) return;

  const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
  const sock = new WebSocket(proto + '//' + location.host + '/ws');
  setWs(sock);

  sock.onopen = () => {
    resetWsRetry();
    setLiveStatus(true);
    // Keepalive ping every 25s
    sock._pingTimer = setInterval(() => {
      if (sock.readyState === 1) sock.send('ping');
    }, 25000);
  };

  sock.onmessage = (e) => {
    if (e.data === 'pong') return;
    try {
      const msg = JSON.parse(e.data);
      handleWSMessage(msg);
    } catch { /* ignore parse errors */ }
  };

  sock.onclose = () => {
    clearInterval(sock._pingTimer);
    setLiveStatus(false);
    // Reconnect: backoff (current wsRetry-ді қолданамыз, сосын incr).
    const delay = Math.min(2000 * Math.pow(2, wsRetry), 30000);
    incrWsRetry();
    setTimeout(connectWS, delay);
  };

  sock.onerror = () => sock.close();
}

export function setLiveStatus(online) {
  const dot = document.getElementById('liveDot');
  const txt = document.getElementById('liveText');
  if (dot) dot.className = 'live-dot ' + (online ? 'on' : 'off');
  if (txt) txt.textContent = online ? 'Тірі байланыс' : 'Қайта қосылуда...';
}

export function handleWSMessage(msg) {
  if (msg.type === 'hello') return;
  if (msg.type !== 'update') return;

  // Stats жаңарту
  if (msg.stats) {
    animateNum('s-reading', msg.stats.reading);
    animateNum('s-finished', msg.stats.finished);
    animateNum('s-want', msg.stats.want);
  }
  if (msg.streak !== undefined) {
    animateNum('s-streak', msg.streak);
    const navStreak = document.getElementById('navStreak');
    if (navStreak) navStreak.textContent = '\uD83D\uDD25 ' + msg.streak + ' күн';
  }

  // Reading list — bot жаңарту жіберсе
  if (msg.reading && msg.from_bot) {
    // 04.10: «Бүгін» беті (оқу карточкалары) өшті — тек хабар қалды.
    botToast('Бот жаңартты! Деректер синхрондалды');
  }
}
